import { render, staticRenderFns } from "./FichaDigital.vue?vue&type=template&id=7eee31a0&"
import script from "./FichaDigital.vue?vue&type=script&lang=js&"
export * from "./FichaDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports